// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DealCardComponent } from '../pddj/deals/deal-card/deal-card.component';
import { MaterialModule } from '../shared/material.module';
import { SharedModule } from '../shared/shared.module';
import { BuyerDealsRoutingModule } from './buyer-deals-container/buyer-deals-routing.module';
import { BuyerDealsComponent } from './buyer-deals-container/buyer-deals/buyer-deals.component';
import { BuyerUploadComponent } from './buyer-doc-container/buyer-upload/buyer-upload.component';
import { BuyerViewComponent } from './buyer-doc-container/buyer-view/buyer-view.component';
import { BuyerSignComponent } from './buyer-doc-container/buyer-sign/buyer-sign.component';
import { BuyerDealCardComponent } from './buyer-deals-container/buyer-deal-card/buyer-deal-card.component';
import { BuyerVehicleInfoComponent } from './buyer-deal-container/buyer-vehicle-info/buyer-vehicle-info.component';
import { BuyerDealComponent } from './buyer-deal-container/buyer-deal/buyer-deal.component';
import { BuyerDealRoutingModule } from './buyer-deal-container/buyer-deal-routing.module';
import { BuyerSettingsComponent } from './buyer-settings/buyer-settings.component';
import { BuyerDocRoutingModule } from './buyer-doc-container/buyer-doc-routing.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { BuyerVehicleInfoHeaderComponent } from './buyer-vehicle-info-header/buyer-vehicle-info-header.component';
import { BuyerHelpComponent } from './buyer-help/buyer-help.component';

@NgModule({
    declarations: [
        BuyerDealCardComponent,
        BuyerDealComponent,
        BuyerDealsComponent,
        BuyerSettingsComponent,
        BuyerSignComponent,
        BuyerUploadComponent,
        BuyerViewComponent,
        BuyerVehicleInfoComponent,
        BuyerVehicleInfoHeaderComponent,
        BuyerHelpComponent,
    ],
    imports: [
        BuyerDealRoutingModule,
        BuyerDealsRoutingModule,
        BuyerDocRoutingModule,
        CommonModule,
        FormsModule,
        MaterialModule,
        ReactiveFormsModule,
        SharedModule,
        MatFormFieldModule,
    ],
    exports: [DealCardComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BuyerModule {}
